import fetch from 'utils/fetch';

export const create = json => {
  return fetch('/pco-manager/aast/cases-creation/new', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};

export const update = (id, step, json, next) => {
  return fetch(
    `/pco-manager/aast/cases-creation/${id}?step=${step}&next=${next}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(json, (key, value) => {
        return value === '' ? undefined : value;
      }),
    }
  );
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/api/index.js